/**
 * Centralized Wiki URLs for the application
 */
export const WIKI_URLS = {
    /** Main Wiki home page */
    HOME: 'https://wiki.syensqo.com/display/IC/SyGPT+Home',
    /** Release notes page */
    RELEASE_NOTES: 'https://wiki.syensqo.com/display/IC/SyGPT+releases',
    /** Terms of Use document */
    TERMS_OF_USE:"https://syensqosa.sharepoint.com/:w:/s/shdsyensqoai/IQDafcZiE_sVUg5hZf76GTLoAb0JkCMNjIfgNVX1lRInRHo?isSPOFile=1&mobileredirect=true"
} as const;
